"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PriceOverrideComponent = void 0;
var _react = require("react");
var _storeProvider = require("../util/storeProvider");
var _textInput = _interopRequireDefault(require("@ux/text-input"));
require("@ux/text-input/styles");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
class PriceOverrideComponent extends _react.Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.validate = this.validate.bind(this);
    this.state = {
      currentPrice: '',
      failure: null,
      min: this.props.minPricePerMonthFormatted ? Number(this.props.minPricePerMonthFormatted.replace(/[^0-9.-]+/g, '')) : '',
      max: this.props.maxPricePerMonthFormatted ? Number(this.props.maxPricePerMonthFormatted.replace(/[^0-9.-]+/g, '')) : ''
    };
  }
  validate(value) {
    let failureMessage = null;
    let isValid = true;
    if (value < this.state.min || value > this.state.max) {
      failureMessage = this.props.content['error-message'];
      isValid = false;
    }
    this.setState({
      failure: failureMessage
    });
    return isValid;
  }
  handleChange(value) {
    this.setState({
      currentPrice: value
    });
  }
  handleBlur(value) {
    if (value && value < this.state.min) {
      value = this.state.min;
    } else if (value && value > this.state.max) {
      value = this.state.max;
    }

    // Ensure decimal precision is at most hundreths
    // Note: JavaScript uses floating point math which can lead to rounding errors:
    //       Because we need an exact result with two decimal places
    //       we must multiply your numbers with 100 before the operation
    //       and then divide again afterwards
    if (value % 1) {
      value = value - value * 100 % 1 / 100;
      this.handleChange(value);
    }
    this.validate(value);
    this.props.handleChange(value);
  }
  render() {
    const {
      minPricePerMonthFormatted,
      maxPricePerMonthFormatted,
      commonContent
    } = this.props;
    const minText = commonContent.minPrice && commonContent.minPrice.replace('{0}', minPricePerMonthFormatted);
    const maxText = commonContent.maxPrice && commonContent.maxPrice.replace('{0}', maxPricePerMonthFormatted);
    const rangeText = minText + ' - ' + maxText;
    return /*#__PURE__*/React.createElement(_textInput.default, {
      label: rangeText,
      type: "number",
      notice: this.props.content['disclaimer-text'],
      invalid: !this.validate,
      errorMessage: !this.validate ? this.state.failure : '',
      onBlur: e => this.handleBlur(e.target.value),
      onChange: e => this.handleChange(e.target.value),
      value: this.state.currentPrice,
      name: this.props.instancePath
    });
  }
}
exports.PriceOverrideComponent = PriceOverrideComponent;
PriceOverrideComponent.propTypes = {
  instancePath: _propTypes.default.string,
  layoutProperties: _propTypes.default.object,
  includeState: _propTypes.default.array,
  content: _propTypes.default.object,
  selectedVal: _propTypes.default.object,
  maxPricePerMonthFormatted: _propTypes.default.string,
  minPricePerMonthFormatted: _propTypes.default.string,
  commonContent: _propTypes.default.object.isRequired,
  handleChange: _propTypes.default.func.isRequired
};
var _default = exports.default = (0, _storeProvider.provideContext)(PriceOverrideComponent);